// Mock data for sections not yet backed by the operator API.
// Each export maps to a backlog subtask under JOBE-0010.8.

export const decideItems = [
  { kind: 'decide', from: 'morgan · tax', title: 'K-1 reclassification', detail: 'which treatment do you prefer?', meta: ['DUE 14:00', 'morgan blocked'], blocking: true },
  { kind: 'approve', from: 'claire · finance', title: '$2,480 → Vanguard', detail: 'policy requires approval (>$1k)', meta: ['today', 'staged'] },
  { kind: 'reply', from: 'eve · exec', title: '', detail: 'Which items should I elevate as today\u2019s priorities?', meta: ['2h ago'] },
];

export const signalItems = [
  { state: 'watch', from: 'platform', text: 'audit backlog growing · +12.4k rows in 24h', age: '1h' },
  { state: 'ok',    from: 'research', text: 'weekly summary ready · 1 item flagged', age: '3h' },
  { state: 'ok',    from: 'finance',  text: 'daily report shipped · cash flow nominal', age: '1h' },
  { state: 'ok',    from: 'home ops', text: 'calendar clean · groceries synced', age: '4h' },
  { state: '',      from: 'banking',  text: 'nightly ingest · 134 txns', age: '8h' },
];

export const dayStrip = [
  { h: 6 },
  { h: 7, blk: true, soft: true },
  { h: 8, blk: true },
  { h: 9, blk: true, now: true },
  { h: 10, blk: true },
  { h: 11 },
  { h: 12, blk: true, soft: true },
  { h: 13, blk: true },
  { h: 14 }, { h: 15 }, { h: 16 }, { h: 17 },
  { h: 18, blk: true },
  { h: 19 },
];

export const myDay = [
  { time: '09:00', title: 'Decide: K-1 reclassification', sub: 'morgan · due 14:00', who: 'NOW', now: true },
  { time: '10:30', title: 'Research review · work block',  sub: '90m · solo',         who: 'SOLO' },
  { time: '13:00', title: 'Approve transfer',              sub: 'claire · $2,480',    who: 'HUMAN' },
];

export const tasks = [
  { title: 'Decide K-1 reclassification',       meta: 'due 14:00' },
  { title: 'Approve $2,480 Vanguard transfer',  meta: 'policy' },
  { title: 'Read weekly research summary',      meta: 'riley' },
  { title: 'Reply: department charter draft',   meta: 'eve · 2d' },
  { title: 'Read morning brief',                meta: '07:02', done: true },
];

export const feed = [
  { time: '09:08', state: 'block', k: 'pol', src: 'finance',   tt: 'transfer flagged · >$1k policy · approval.requested', tag: 'POLICY' },
  { time: '08:41', state: 'watch', k: 'svc', src: 'platform',  tt: 'audit backlog +12,431 rows · iris flagged', tag: 'SVC' },
  { time: '08:10', state: 'ok',    k: 'rpt', src: 'finance',   tt: 'daily report ready (claire)', tag: 'RPT' },
  { time: '08:02', state: '',      k: 'msg', src: 'iris',      tt: 'note: retention job recommended', tag: 'NOTE' },
  { time: '07:33', state: 'ok',    k: 'evt', src: 'research',  tt: '3 notes synthesized · riley', tag: 'EVT' },
  { time: '07:02', state: 'ok',    k: 'rpt', src: 'executive', tt: 'morning briefing shipped (eve) · 48 inputs', tag: 'RPT' },
  { time: '06:45', state: 'ok',    k: 'rpt', src: 'research',  tt: 'weekly summary synthesized', tag: 'RPT' },
  { time: '06:30', state: '',      k: 'evt', src: 'home',      tt: 'grocery list synced · shawn', tag: 'EVT' },
  { time: '04:12', state: '',      k: 'evt', src: 'platform',  tt: 'cedar policy reload · permit-all-mvp', tag: 'CFG' },
  { time: '02:30', state: '',      k: 'evt', src: 'banking',   tt: 'balance reconciliation ok', tag: 'EVT' },
  { time: '01:04', state: '',      k: 'evt', src: 'banking',   tt: 'nightly transaction ingest · 134 txns', tag: 'EVT' },
  { time: '00:15', state: '',      k: 'evt', src: 'research',  tt: 'rss crawl · 241 items ingested', tag: 'EVT' },
];

export const messages = [
  { cls: 'app', title: 'Transfer $2,480 → Vanguard', lede: 'claire · policy requires approval · 5m ago', label: 'APPR' },
  { cls: 'ask', title: 'K-1 reclassification',        lede: 'morgan · which treatment do you prefer?', label: 'ASK' },
  { cls: 'dm',  title: 'Brief ready — priorities?',   lede: 'eve · 2h ago', label: 'DM' },
  { cls: 'note', title: 'Audit backlog growing',       lede: 'iris · recommend longer retention job', label: 'NOTE' },
];

export const reports = [
  { name: 'Morning Briefing · today', time: '07:02', today: true },
  { name: 'Finance daily',   time: '08:10' },
  { name: 'Research weekly', time: '06:45' },
  { name: 'Platform weekly', time: '2d ago' },
  { name: 'Incident · banking-tool', time: 'Apr 12' },
];

export const paletteItems = [
  { group: 'Ask', cls: 'ask', icon: '?', name: 'What changed in the last hour?', sub: 'eve · natural language', kb: '\u21B5' },
  { group: 'Ask', cls: 'ask', icon: '?', name: 'Summarize platform health this week', sub: 'eve' },
  { group: 'Jump', cls: 'jump', icon: '\u2192', name: 'Finance', sub: 'department' },
  { group: 'Jump', cls: 'jump', icon: '\u2192', name: 'Morning Briefing', sub: 'report · today' },
  { group: 'Jump', cls: 'jump', icon: '\u2192', name: 'claire', sub: 'actor' },
  { group: 'Invoke', cls: 'invoke', icon: '!', name: 'record_task', sub: 'platform tool' },
  { group: 'Invoke', cls: 'invoke', icon: '!', name: 'create_proposal', sub: 'platform tool' },
  { group: 'Invoke', cls: 'invoke', icon: '!', name: 'spawn agent', sub: 'platform tool' },
];
